export default __webpack_public_path__ + "static/media/image20.49015040.jpg";